<template>
	<button class="more-btn">
        <span class="more-dot"></span>
        <span class="more-dot"></span>
        <span class="more-dot"></span>
    </button>
</template>

<script>
	export default {
	  name: "MoreDotsButton"
	};
</script>

<style lang="scss" scoped>
    @import '~scss/utilities/initial-variables.scss';
    @import '~scss/utilities/derived-variables.scss';
	.more-btn {
        background: none;
        border: 0 none;
        line-height: normal;
        overflow: visible;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        width: 100%;
        text-align: left;
        outline: none;
        cursor: pointer;
        .more-dot {
            background-color: $grey-light;
            margin: 0 auto;
            display: inline-block;
            width: 0.3125rem;
            height: 0.3125rem;
            margin-right: 0.044rem;
            border-radius: 50%;
            transition: background-color 0.3s;
        }
        &:hover .more-dot {
            background-color: $grey;
        }
    }	
</style>